module.exports = {
  content: ["./src/**/*.{js,jsx,ts,tsx}"],
  safelist: [{ pattern: /anticimex-button-/, variants: ["disabled", "focus", "hover"] }],
  theme: {
    fontFamily: {
      "anticimex-default": ["Anticimex Sans"]
    },
    minWidth: {
      sm: "375px",
      "sm-padding": "343px"
    },
    namedGroups: ["tier-2"],
    screens: {
      "sm": "640px",
      "md": "768px",
      "lg": "1024px",
      "xl": "1280px",
      "2xl": "1440px",
      "3xl": "1920px",
      "4xl": "2560px"
    },
    extend: {
      borderWidth: {
        1: "1px",
        3: "3px",
        7: "7px"
      },
      colors: {
        "inherit": "inherit",

        "neutral-20": "var(--neutral-20)",
        "neutral-40": "var(--neutral-40)",
        "neutral-70": "var(--neutral-70)",
        "neutral-75": "var(--neutral-75)",
        "neutral-80": "var(--neutral-80)",
        "neutral-85": "var(--neutral-85)",
        "neutral-90": "var(--neutral-90)",
        "neutral-95": "var(--neutral-95)",
        "neutral-100": "var(--neutral-100)",
        "neutral-100-dim": "var(--neutral-100-dim)",

        "brand-primary-10": "var(--blue-10)",
        "brand-primary-20": "var(--blue-20)",
        "brand-primary-30": "var(--blue-30)",
        "brand-primary-40": "var(--blue-40)",
        "brand-primary-50": "var(--blue-50)",
        "brand-primary-60": "var(--blue-60)",
        "brand-primary-70": "var(--blue-70)",
        "brand-primary-75": "var(--blue-75)",
        "brand-primary-80": "var(--blue-80)",
        "brand-primary-85": "var(--blue-85)",
        "brand-primary-90": "var(--blue-90)",
        "brand-primary-95": "var(--blue-95)",
        "brand-primary-95-dark": "var(--blue-95-dark)",
        "brand-primary-100": "var(--blue-100)",
        "brand-primary-dim": "var(--blue-dim-30)",
        "brand-primary-dim-80": "var(--blue-dim-80)",
        "brand-primary-dim-70": "var(--blue-dim-70)",

        "brand-secondary-50": "var(--green-50)",
        "brand-secondary-60": "var(--green-60)",
        "brand-secondary-65": "var(--green-65)",
        "brand-secondary-70": "var(--green-70)",
        "brand-secondary-90": "var(--green-90)",
        "brand-secondary-90-dark": "var(--green-90-dark)",
        "brand-secondary-100": "var(--green-100)",

        "brand-tertiary-50": "var(--red-50)",
        "brand-tertiary-70": "var(--red-70)",
        "brand-tertiary-90": "var(--red-90)",

        "brand-senary-40": "var(--neutral-40)",
        "brand-senary-80": "var(--neutral-80)",
        "brand-senary-85": "var(--neutral-85)",
        "brand-senary-90": "var(--neutral-90)",
        "brand-senary-95": "var(--neutral-95)",
        "brand-senary-100": "var(--neutral-100)",

        /* Element specific */
        "link": "var(--blue-60)",
        "label": "var(--neutral-40)",
        "input-border": "var(--blue-90)",
        "input-border-focused": "var(--blue-50)",
        "input-bg-dragging": "var(--blue-70-alpha-15)",
        "input-bg-readonly": "var(--blue-dim-90)",
        "paragraph-primary": "var(--neutral-0-alpha-80)",
        "paragraph-secondary": "var(--neutral-20)",
        "paragraph-highlighted": "var(--blue-20-alpha-87)",
        "paragraph-border": "var(--blue-95)",
        "form-border": "var(--blue-95)",
        "form-section-border": "var(--neutral-0-alpha-5)",
        "form-bg": "var(--neutral-100)",
        "form-summary-label": "var(--blue-20-alpha-64)",
        "form-summary": "var(--blue-20-alpha-87)",

        "rating-star-highlighted": "var(--orange-50)",

        /* TODO: What to call this? */
        "h1-alternate": "var(--blue-70)",
        "h1-alternate-2": "var(--blue-50)",
        "h3-primary": "var(--blue-30)",

        /* Shared */
        "separator": "var(--blue-90)",
        "separator-subtle": "var(--neutral-85)",
        "subheader-primary": "var(--blue-dim-30)",
        "button-primary-color": "var(--neutral-100)",
        "button-primary-variant-bg": "var(--green-50)",
        "button-transparent-color": "var(--neutral-100)",

        /* Component Specific */
        "hero-with-overlay-text": "var(--neutral-100)",
        "hero-with-overlay-subtitle": "var(--blue-90)",
        "hero-image-text": "var(--blue-70)",
        "hero": "var(--blue-30)",
        "hero-overlay": "var(--blue-20-alpha-80)",

        "breadcrumbs-active": "var(--neutral-40)",

        "contact-info-h4": "var(--blue-20-alpha-87)",

        "selected-navigation-topic": "var(--blue-95)",

        "banner-subtitle-color-variant-1": "var(--blue-80)",
        "banner-text-color-variant-1": "var(--neutral-100)",
        "banner-bg-color-variant-1": "var(--blue-30)",
        "banner-button-text-color-variant-1": "var(--neutral-100)",
        "banner-button-bg-color-variant-1": "var(--blue-70)",

        "banner-subtitle-color-variant-2": "var(--blue-dim-30)",
        "banner-text-color-variant-2": "var(--blue-30)",
        "banner-bg-color-variant-2": "var(--blue-100)",
        "banner-overlay": "var(--blue-20-alpha-80)",

        "imageText-subtitle-color-variant-1": "var(--blue-80)",
        "imageText-text-color-variant-1": "var(--neutral-100)",
        "imageText-bg-color-variant-1": "var(--blue-30)",
        "imageText-button-text-color-variant-1": "var(--neutral-100)",
        "imageText-button-bg-color-variant-1": "var(--blue-70)",

        "imageText-subtitle-color-variant-2": "var(--blue-dim-30)",
        "imageText-text-color-variant-2": "var(--blue-30)",
        "imageText-bg-color-variant-2": "var(--blue-100)",
        "imageText-overlay": "var(--blue-20-alpha-80)",

        "pest-card-border": "var(--blue-95)",
        "pest-card-arrow": "var(--blue-95)",

        "bullet-list-bg": "var(--blue-100)",
        "bullet-list-border": "var(--blue-90)",

        "footer-bg": "var(--blue-30)",
        "footer-text-color": "var(--neutral-100)",
        "footer-social-text-color": "var(--blue-80)",
        "footer-link-hover": "var(--blue-85)",

        "municipalities": "var(--neutral-20)",

        "navigation-link": "var(--blue-30)",
        "navigation-link-hover": "var(--blue-50)",
        "navigation-icon": "var(--blue-20)",

        "step-by-step-number-bg": "var(--blue-95)",

        "tab-active": "var(--blue-30)",
        "tab-inactive": "var(--blue-dim-30)",

        "facts-list-circle-bg": "var(--blue-95)",

        "background-blocks": "var(--blue-70)",
        "blog-primary-20": "var(--blue-20)",
        "blog-primary-30": "var(--blue-30)",

        /* Identifier filter */
        "identifier-filter-button": "var(--blue-95)",

        /* Icon text block */
        "icon-text-hover": "var(--blue-70-dark)",

        "review-text-50": "var(--white-50)",
        "review-text-60": "var(--white-60)",

        /* No offices found section */
        "warning": "var(--warning)",
        "warning-26": "var(--warning-26)",
        "yellow-gray": "var(--yellow-gray)"
      },
      gridTemplateRows: {
        "12-dense": "repeat(12, auto)",
        "18-dense": "repeat(18, auto)",
        "24-dense": "repeat(24, auto)",
        "36-dense": "repeat(36, auto)"
      },
      lineHeight: {
        "h1-extra-tight": 1.11
      },
      width: {
        "2.5": "0.625rem",
        "160": "40rem",
        "1/10": "10%",
        "9/10": "90%",
        "3/20": "15%",
        "1/5": "20%",
        "1/4": "25%",
        "1/3": "33.3333%",
        "1/2": "50%",
        "2/3": "66.6666%",
        "3/4": "75%",
        "icon-text-block": "9rem"
      },
      maxWidth: {
        "48": "12rem",
        "50": "14rem",
        "1/4": "25%",
        "1/3": "33.3333%",
        "1/2": "50%",
        "2/3": "66.6666%",
        "3/4": "75%",
        "10xl": "104rem",
        "600px": "600px",
        "aside-with-shadows": "calc(1280px + 2rem)",
        "td-mobile": "80vw",
        "td-desktop": "none"
      },
      minWidth: {
        "full": "100%",
        "card-small": "260px",
        "table": "100%",
        "0.5": "0.125rem",
        "1": "0.25rem",
        "1.5": "0.375rem",
        "2": "0.5rem",
        "2.5": "0.625rem",
        "3": "0.75rem",
        "3.5": "0.875rem",
        "4": "1rem",
        "5": "1.25rem",
        "6": "1.5rem",
        "7": "1.75rem",
        "8": "2rem",
        "9": "2.25rem",
        "10": "2.5rem",
        "11": "2.75rem",
        "12": "3rem",
        "14": "3.5rem",
        "16": "4rem",
        "20": "5rem",
        "24": "6rem",
        "28": "7rem",
        "32": "8rem",
        "36": "9rem",
        "40": "10rem",
        "44": "11rem",
        "48": "12rem",
        "52": "13rem",
        "56": "14rem",
        "60": "15rem",
        "64": "16rem",
        "72": "18rem",
        "80": "20rem",
        "96": "24rem"
      },
      minHeight: {
        "municipalities-list": "25rem",
        "help-card": "28.125rem",
        "help-card-small": "23.75rem",
        "hero-image": "34rem",
        "hero-image-with-overlay-mobile": "28rem"
      },
      maxHeight: {
        "1/10": "10%",
        "2/10": "20%",
        "3/10": "30%",
        "4/10": "40%",
        "5/10": "50%",
        "6/10": "60%",
        "7/10": "70%",
        "8/10": "80%",
        "9/10": "90%",
        "hero-image-max": "50vh"
      },
      height: {
        "2.5": "0.625rem",
        "14": "3.5rem",
        "30": "7.5rem",
        "34": "8.5rem",
        "icon-text-block": "9rem",
        "hero-image-with-overlay-mobile": "28rem",
        "hero-image-mobile": "16rem",
        "hero-image": "36vw",
        "hero-image-2xl": "25vw",
        "hero-image-3xl": "20vw",
        "hero-image-overlay": "42rem",
        "divider-thick": "5px",
        "px-2": "2px"
      },
      inset: {
        "filter-icon": "10px",
        "filter-icon-mobile": "4px",
        "1/10": "10%",
        "1/5": "20%",
        "1/4": "25%",
        "1/2": "50%",
        "full": "100%"
      },
      margin: {
        "2.5": "0.625rem",
        7: "1.625rem",
        "100": "6.25rem",
        "200": "12.5rem",
        "-72": "-18rem",
        "negate-border-1": "-1px",
        "negate-border-2": "-2px",
        "px": "1px",
        "px-2": "2px",
        "px-3": "3px"
      },
      padding: {
        "2.5": "0.625rem",
        7: "1.625rem",
        9: "2.25rem",
        "100": "6.25rem",
        "200": "12.5rem",
        "16/9": "56.25%",
        "button-xs": "0.25rem",
        "button-sm": "0.625rem",
        "button-md": "0.875rem",
        "button-lg": "2rem",
        "button-xl": "5rem"
      },
      fontSize: {
        "sm-base": "0.875rem", // Just between "text-base" and "text-sm"
        "base-lg": "1.0625rem", // between base and lg
        "3.5xl": "2rem",
        "4.5xl": "2.5rem",
        "7xl": "4.5rem",
        "8xl": "5rem",
        "9xl": "6rem",
        "inherit-size": "inherit"
      },
      rounded: {
        "sm-md": "0.25rem" // Just between rounded-sm and rounded-md
      },
      boxShadow: {
        "card": "0 24px 64px -24px rgba(0, 0, 0, 0.1)",
        "card-lifted": "0 32px 64px -16px rgba(0, 0, 0, 0.15)",
        "card-outline":
          "0 24px 64px -24px rgba(0, 0, 0, 0.1), 0 0 0 5px rgba(24, 126, 224, 0.3)",

        "outline": "0 0 0 5px rgba(24, 126, 224, 0.3)",
        "outline-primary": "0 0 0 5px rgba(13, 43, 136, 0.3)",
        "outline-primary-light": "0 0 0 5px rgba(54, 148, 237, 0.3)",
        "outline-primary-inverted": "0 0 0 5px rgba(13, 43, 136, 0.3)",
        "outline-primary-transparent": "0 0 0 5px rgba(255, 255, 255, 0.3)",
        "outline-secondary": "0 0 0 5px rgba(30, 214, 140, 0.3)",
        "outline-neutral": "0 0 0 5px rgba(255, 255, 255, 0.3)",

        "outline-error": "0 0 0 5px rgba(224, 24, 24, 0.3)",

        "modal":
          "-16px -16px 32px rgba(255, 255, 255, 0.16), 16px 16px 32px rgba(0, 0, 0, 0.08)",

        "multiline-text-primary-solid":
          "-6px 0 0 3px var(--blue-70), 6px 0 0 3px var(--blue-70)",
        "multiline-text-primary-solid-lg":
          "-12px 3px 0 3px var(--blue-70), 12px 3px 0 3px var(--blue-70)",

        "soft-2xl": "0 24px 64px -24px rgba(0, 0, 0, 0.1)",
        "soft-sm": "0 4px 16px 0 rgba(0, 0, 0, 0.1)"
      },
      opacity: {
        "1": "0.1",
        "2": "0.2"
      },
      zIndex: {
        1: 1,
        "modal": 40
      },
      keyframes: {
        "preview-loader-exit": {
          "20%": {
            "transform": "translateX(20px)"
          },
          "100%": {
            "transform": "translateX(-200%)"
          }
        },

        "preview-loader-enter": {
          "0%": {
            "transform": "translateX(-200%)"
          },
          "80%": {
            "transform": "translateX(20px)"
          },
          "100%": {
            "transform": "translateX(0px)"
          }
        }
      },
      animation: {
        "preview-loader-exit": "preview-loader-exit 0.5s ease 1 normal forwards",
        "preview-loader-enter": "preview-loader-enter 0.5s ease 1 normal forwards"
      }
    }
  },
  plugins: [require("tailwindcss-named-groups")]
};

